module.exports = __webpack_public_path__ + "img/流体力学3_2.57be525f.jpg";